/**
 * object to populate dashboard UI
 */
 
 let Applicant_Dashboard_Object = {
   "applicantId": -99,
   "isAccepted": false,
   "isDeclined": false,
   "isApplicationCompleted": false,
   "completePecent": 0,
   "applicationStatus": null, // "",
   "requestNewStatementPurpose" : 0, 
   "requestNewLetterSupport" : 0,
   "applicationChecklist": [],  /* sample: {id: 0, isCompleted: false, label: "Application submitted", status:"notStarted",  content: "in progress" */  
   "requirementList": [],
   "clearanceList": []
       /* sample: {id: 0,
       status:"notStarted",
       content: "in progress", // Completed
       label: "Human Resources (HR) and Occupational Health Services (OHS) Clearance"
      }*/
     
};




export {Applicant_Dashboard_Object};